<template>
  <div
    v-loading="!plansLoaded || loading"
    class="update-payment-info"
    data-test="page-updatepremium">
    <h2 class="m-b t-c font-normal heading">
      {{ heading }}
    </h2>
    <div
      v-if="!isSubscribed || isCanceled"
      class="sub-head t-c">
      <div v-if="!isSubscribed && !isCanceled">Enter your billing information to start your free trial</div>
      <div>Premium is {{ defaultPrice.price | amountFilter(defaultPrice.currency) }} {{ defaultPrice.price | taxFilter(defaultPrice.currency) }}. Cancel Anytime.</div>
    </div>
    <el-form
      ref="paymentForm"
      :model="paymentForm"
      :rules="paymentValidationRules"
      label-position="top"
      @keyup.enter.native="onSubmit"
    >
      <el-row :gutter="12">
        <el-col :span="12">
          <el-form-item
            id="firstName"
            prop="firstName"
            label="First Name"
          >
            <el-input
              v-model="paymentForm.firstName"
              placeholder="First name"
              data-test="input-firstname"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            id="lastName"
            prop="lastName"
            label="Last Name"
          >
            <el-input
              v-model="paymentForm.lastName"
              placeholder="Last name"
              data-test="input-lastname"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <div class="cards-div">
        <div class="js-chckt-pm__pm-holder">
          <input
            type="hidden"
            name="txvariant"
            value="card"
          >
          <el-row :gutter="12">
            <el-col
              :md="15"
              :sm="14"
              :xs="16">
              <el-form-item
                label="Credit Card #"
              >
                <div class="custom-card-number d-flex flex-middle-align">
                  <div>
                    <label>
                      <span
                        id="encryptedCardNumberSpan"
                        class="input-field"
                        data-cse="encryptedCardNumber"
                        data-test="input-creditcard"
                      />
                    </label>
                  </div>
                  <div class="card-brand"><img :src="cardIcon"></div>
                </div>
              </el-form-item>
            </el-col>
            <el-col
              :md="9"
              :sm="10"
              :xs="8">
              <el-form-item
                label="Exp. Date"
                class="custom-exp-date"
              >
                <div>
                  <el-row
                    type="flex"
                    align="middle">
                    <el-col
                      :md="5"
                      :sm="5"
                      :xs="10">
                      <el-form-item class="exp-month">
                        <label>
                          <span
                            id="encryptedExpiryMonthSpan"
                            class="input-field"
                            data-cse="encryptedExpiryMonth"
                          />
                        </label>
                      </el-form-item>
                    </el-col>
                    <el-col
                      :span="2"
                      class="t-c">/</el-col>
                    <el-col
                      :md="5"
                      :sm="5"
                      :xs="10">
                      <el-form-item class="exp-year">
                        <label>
                          <span
                            id="encryptedExpiryYearSpan"
                            class="input-field"
                            data-cse="encryptedExpiryYear"
                          />
                        </label>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="12">
            <el-col
              :md="4"
              :sm="8"
              :xs="12">
              <el-form-item
                label="CVV"
              >
                <div class="custom-cvv">
                  <label>
                    <span
                      class="input-field"
                      data-cse="encryptedSecurityCode"
                    />
                  </label>
                </div>
              </el-form-item>
            </el-col>
            <el-col
              :md="10"
              :sm="8"
              :xs="12">
              <el-form-item
                id="postalCode"
                :label="zipCodeLabel"
                prop="postalCode"
                label-position="top"
              >
                <el-input
                  v-model="paymentForm.postalCode"
                  :placeholder="postalCodePlaceholder"
                  data-test="input-zipcode"
                />
              </el-form-item>
            </el-col>
            <el-col
              v-show="showState"
              :md="10"
              :sm="8"
              :xs="0">
              <el-form-item
                id="state"
                :label="stateLabel"
                prop="state"
                label-position="top">
                <el-select
                  :popper-append-to-body="false"
                  v-model="paymentForm.state"
                  :placeholder="statePlaceholder"
                  no-match-text="Not found"
                  filterable
                  data-input="select-state"
                  @keyup.native.enter="preventSubmit">
                  <el-option
                    v-for="(state, index) in states"
                    :key="index"
                    :label="state.name"
                    :value="state.code"
                    data-test="option-state"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              v-if="!showState"
              :md="10"
              :sm="8"
              :xs="12"
            >
              <el-form-item
                id="country"
                prop="country"
                label="Country"
                label-position="top">
                <el-select
                  :popper-append-to-body="false"
                  v-model="paymentForm.country"
                  placeholder="Select country"
                  no-match-text="Not found"
                  filterable
                  data-test="select-country"
                  @change="onCountryChange"
                  @keyup.native.enter="preventSubmit">
                  <el-option
                    v-for="(country, index) in countries"
                    :key="index"
                    :label="country.name"
                    :value="country.code"
                    data-test="option-country" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col
              v-if="showState"
              :md="0"
              :sm="0"
              :xs="12"
            >
              <el-form-item
                id="state"
                :label="stateLabel"
                prop="state"
                label-position="top">
                <el-select
                  :popper-append-to-body="false"
                  v-model="paymentForm.state"
                  :placeholder="statePlaceholder"
                  no-match-text="Not found"
                  filterable
                  @keyup.native.enter="preventSubmit">
                  <el-option
                    v-for="(state, index) in states"
                    :key="index"
                    :label="state.name"
                    :value="state.code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              v-show="showState"
              :md="9"
              :sm="9"
              :xs="12">
              <el-form-item
                id="country"
                prop="country"
                label="Country"
                label-position="top">
                <el-select
                  :popper-append-to-body="false"
                  v-model="paymentForm.country"
                  placeholder="Select country"
                  no-match-text="Not found"
                  filterable
                  data-test="select-country"
                  @change="onCountryChange"
                  @keyup.native.enter="preventSubmit">
                  <el-option
                    v-for="(country, index) in countries"
                    :key="index"
                    :label="country.name"
                    :value="country.code"
                    data-test="option-country" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>
    <el-alert
      v-if="zuoraErrorMessage"
      :title="zuoraErrorMessage"
      type="error"
      class="m-b"
      show-icon
    />
    <p
      v-if="!isSubscribed && !isCanceled"
      class="legal-terms">
      <span v-if="!isSubscribed && !isCanceled">By clicking "Subscribe" you are signing up for a free <span
        v-if="trailMonths > 1"
        class="line-through">1 month</span> {{ trailMonths }} {{ trailMonths > 1 ? 'months' : 'month' }} trial. Your trial will begin immediately. If you don’t cancel before the end of the trial period, you authorize Luminary to automatically charge your payment method {{ defaultPrice.price | amountFilter(defaultPrice.currency) }} {{ defaultPrice.price | taxFilter(defaultPrice.currency) }} on a continuous monthly basis for as long as you remain a subscriber.</span>
      You can cancel anytime by visiting your Account Settings. No partial refunds.
      <router-link
        target="_blank"
        color="primary"
        to="/termsfreetrial"
        data-test="link-additionalterms"
        class="font-normal t-u"
      >
        Additional terms apply.
      </router-link>
    </p>
    <p
      v-if="isResubscribingAfterTrial"
      class="legal-terms"
    >
      By clicking on “subscribe” you are purchasing a monthly Luminary Premium subscription. Your subscription will begin and you will be charged immediately. You authorize Luminary to automatically charge your payment method $7.99/month + applicable taxes on a continuous monthly basis for as long as you remain a subscriber. You can cancel anytime by visiting your account settings. No partial refunds.
      <router-link
        target="_blank"
        color="primary"
        to="/termsfreetrial"
        data-test="link-additionalterms"
        class="font-normal t-u"
      >
        Additional terms apply.
      </router-link>
    </p>
    <p
      v-if="isResubscribingInTrial"
      class="legal-terms"
    >
      By clicking on “subscribe” you are purchasing a monthly Luminary Premium subscription. Your subscription will begin and you will be charged when your free trial ends. You authorize Luminary to automatically charge your payment method $7.99/month + applicable taxes on a continuous monthly basis for as long as you remain a subscriber. You can cancel anytime by visiting your account settings. No partial refunds.
      <router-link
        target="_blank"
        color="primary"
        to="/termsfreetrial"
        data-test="link-additionalterms"
        class="font-normal t-u"
      >
        Additional terms apply.
      </router-link>
    </p>
    <div class="">
      <el-button
        v-loading="loading"
        type="primary"
        class="action-button"
        data-test="btn-subscribe"
        @click="onSubmit"
      >
        Subscribe
      </el-button>
    </div>
  </div>
</template>
<script>
import Subscription from '../../services/Subscription';
import User from '../../services/User';
import validationRules from '../../shared/validationRules';
import SubscriptionMixin from '../../shared/subscriptionMixin';
import countries from '../../assets/json/countries';
import usStates from '../../assets/json/usStates';
import caStates from '../../assets/json/caStates';

export default {
  name: 'UpdatePaymentInfoComponent',
  mixins: [SubscriptionMixin],
  props: {
    show_modal: {
      default: false,
      type: Boolean,
    },
    update: {
      default: false,
      type: Boolean,
    },
    heading: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      subscriptionProvider: new Subscription(),
      userProvider: new User(),
      plan_id: 'ignite',
      paymentForm: {
        firstName: '',
        lastName: '',
        currency: '',
        name: '',
        cardNumber: '',
        expirationMonth: '',
        expirationYear: '',
        securityCode: '',
        postalCode: '',
        country: this.$store.getters.country || '',
        state: '',
      },
      rules: validationRules.payment,
      countries,
      caStates,
      usStates,
      activePlan: this.$store.getters.activePlan,
      loading: false,
      defaultPrice: this.$store.getters.pricing,
    };
  },
  computed: {
    paymentValidationRules() {
      const paymentRules = validationRules.payment;

      if (this.paymentForm.country === 'US') {
        return {
          ...paymentRules,
          postalCode: [
            {
              required: true,
              pattern: '^[0-9]{5}$',
              message: 'Enter valid zip code.',
              trigger: 'blur',
            },
          ],
        };
      }

      if (this.paymentForm.country === 'CA') {
        return {
          ...paymentRules,
          state: [
            {
              required: true,
              message: 'Province is required.',
              trigger: 'change',
            },
          ],
          postalCode: [
            {
              required: true,
              validator: this.validatePostalCode,
              trigger: 'blur',
            },
          ],
        };
      }

      if (this.paymentForm.country !== 'US' && this.paymentForm.country !== 'CA') {
        return {
          ...paymentRules,
          state: [
            {
              required: false,
            },
          ],
        };
      }
      return paymentRules;
    },
    userSubscription() {
      return this.$store.getters.userSubscription;
    },
    activeProduct() {
      return this.$store.getters.activePlan;
    },
    usersDefaultCountry() {
      return this.$store.getters.country;
    },
    states() {
      let states;
      if (this.paymentForm.country === 'US') {
        states = usStates;
      } else if (this.paymentForm.country === 'CA') {
        states = caStates;
      }
      return states;
    },
    showState() {
      return this.paymentForm.country === 'US' || this.paymentForm.country === 'CA';
    },
    stateLabel() {
      let label = 'Billing State';
      if (this.paymentForm.country === 'CA') {
        label = 'Billing Province';
      }
      return label;
    },
    statePlaceholder() {
      let label = 'Select State';
      if (this.paymentForm.country === 'CA') {
        label = 'Select Province';
      }
      return label;
    },
    postalCodePlaceholder() {
      let placeholder = 'Enter postal code';
      if (this.paymentForm.country === 'US') {
        placeholder = 'Enter zip code';
      }
      return placeholder;
    },
    zipCodeLabel() {
      let label = 'Billing Postal Code';
      if (this.paymentForm.country === 'US') {
        label = 'Billing Zip Code';
      }
      return label;
    },
    isSubscribed() {
      return this.$store.getters.user && this.$store.getters.user.is_subscribed;
    },
    isCanceled() {
      return this.$store.getters.userSubscription && this.$store.getters.userSubscription.is_cancelled;
    },
    usersCountryPricing() {
      return this.$store.getters.pricing;
    },
    trailMonths() {
      let trialMonths = localStorage.getItem('promo_trial_period');
      if (this.isSubscribed) {
        trialMonths = 1;
      }
      return trialMonths || 1;
    },
    user() {
      return this.$store.getters.user;
    },
    isResubscribingAfterTrial() {
      return this.user && !this.user.is_subscribed && this.user.is_on_boarded && this.userSubscription.subscription_status !== 'FREE TRIAL';
    },
    isResubscribingInTrial() {
      return this.user && !this.user.is_subscribed && this.user.is_on_boarded && this.userSubscription.subscription_status === 'FREE TRIAL';
    },
  },
  watch: {
    show_modal(newVal) {
      if (!newVal) {
        this.$refs.paymentForm.resetFields();
      }
      this.initAdyenForm();
      this.populateUserName();
      // this.paymentForm.country = this.$store.getters.country;
    },
    userSubscription(newVal) {
      this.subscription = newVal;
    },
    activeProduct(newVal) {
      if (newVal) {
        this.activePlan = newVal;
      }
    },
    usersDefaultCountry(newVal) {
      if (newVal) {
        this.paymentForm.country = newVal;
      }
    },
    usersCountryPricing(newVal) {
      if (newVal) {
        this.defaultPrice = newVal;
      }
    },
  },
  mounted() {
    this.initAdyenForm();
    this.checkCountryIsWhiteListed();
    this.populateUserName();
    this.activePlan = this.$store.getters.activePlan;
  },
  methods: {
    onSubmit() {
      const paymentMethod = this.validateForm();
      if (paymentMethod) {
        if (this.update) {
          this.updatePaymentInfo(paymentMethod);
        } else {
          this.subscribe(paymentMethod);
        }
      }
    },
    formatUpdatePaymentRequestData(paymentInfo) {
      const country = this.countries.find(nextItem => nextItem.code === this.paymentForm.country);
      const requestData = {
        billToContact: {
          country: this.paymentForm.country,
          firstName: this.paymentForm.firstName,
          lastName: this.paymentForm.lastName,
          postalCode: this.paymentForm.postalCode,
          state: this.paymentForm.state,
        },
        currency: country.currency,
        paymentInfo,
        returnUrl: window.location.origin,
      };
      return requestData;
    },
    updatePaymentInfo(paymentInfo) {
      const subscriptionData = this.formatUpdatePaymentRequestData(paymentInfo);
      this.loading = true;
      this.subscriptionProvider.updatePaymentInfo(subscriptionData)
        .then(this.updatePaymentResponse)
        .catch((error) => {
          this.loading = false;
          this.showErrorMsg(error || 'D’oh. We’re experiencing technical difficulties. Please try again later or contact support@luminary.audio');
        });
    },
    updatePaymentResponse(resp) {
      this.loading = false;
      if (resp) {
        if (resp && !resp.trial_end_date) {
          resp.trial_end_date = this.calculateTrialEndDateLocally();
        }
        this.$store.commit('setUserSubscription', resp);
        const { user } = this.$store.getters;
        user.is_subscribed = true;
        user.first_name = this.paymentForm.firstName;
        user.last_name = this.paymentForm.lastName;
        this.showSuccessMsg('Successfully updated payment info.');
        this.$store.commit('setUser', user);
        this.$emit('success');
      }
    },
    subscribe(paymentInfo) {
      const subscriptionData = this.formatSubscribeRequestData(paymentInfo);
      this.loading = true;
      const clickedID = this.getImpactClickId();

      // Pass ImpactRadius ClickedID if present query param
      if (clickedID) {
        const pricing = this.fetchTargetCountryPrice();
        subscriptionData.total_price = parseFloat(pricing.price);
        subscriptionData.ir_click_id = clickedID;
      }

      this.subscriptionProvider.createSubscription(subscriptionData)
        .then(this.subscriptionResponse)
        .catch((error) => {
          this.loading = false;
          this.showErrorMsg(error || 'D’oh. We’re experiencing technical difficulties. Please try again later or contact support@luminary.audio');
        });
    },
    formatSubscribeRequestData(paymentInfo) {
      // const { activePlan } = this.$store.getters;
      const country = this.countries.find(nextItem => nextItem.code === this.paymentForm.country);
      const promoCode = localStorage.getItem('promo_code');
      const requestData = {
        accountInfo: {
          billToContact: {
            country: this.paymentForm.country,
            firstName: this.paymentForm.firstName,
            lastName: this.paymentForm.lastName,
            postalCode: this.paymentForm.postalCode,
            state: this.paymentForm.state,
          },
          currency: country.currency,
          name: `${this.paymentForm.firstName} ${this.paymentForm.lastName}`,
        },
        paymentInfo,
        planId: this.activePlan && this.activePlan.id ? this.activePlan.id : '',
        returnUrl: window.location.origin,
        total_price: this.defaultPrice.price,
      };
      if (promoCode) {
        requestData.promoCode = promoCode;
        requestData.branchPromo = localStorage.getItem('branch_promo');
      }
      const currentDate = new Date();
      const timeOffset = currentDate.getTimezoneOffset();
      requestData.timezoneOffset = timeOffset;
      return requestData;
    },
    subscriptionResponse(resp) {
      this.loading = false;
      if (resp && resp.is_provisional_subscription) {
        if (resp && !resp.trial_end_date) {
          resp.trial_end_date = this.calculateTrialEndDateLocally();
          resp.is_first_subscription = true;
        }

        // check if user's selected country on subscription is different from previous subscription record
        // then show default pricing of selected country throughtout app
        if (resp.country !== this.userSubscription.country) {
          const defaultPricing = {
            currency: resp.currency,
            price: resp.total_price,
          };
          this.$store.commit('setPricing', defaultPricing);
        }

        this.$store.commit('setUserSubscription', resp);
        const { user } = this.$store.getters;
        user.is_subscribed = true;
        user.first_name = this.paymentForm.firstName;
        user.last_name = this.paymentForm.lastName;
        this.showSuccessMsg('Successfully subscribed to Luminary Premium');
        this.$store.commit('setUser', user);
        if (localStorage.getItem('branch_promo') !== null) {
          const params = {
            bpromo: localStorage.getItem('branch_promo'),
            monthsfree: localStorage.getItem('promo_trial_period'),
          };
          this.$analytics.identify(user.uuid, params);
        }
        localStorage.removeItem('promo_code');
        localStorage.removeItem('promo_trial_end_date');
        localStorage.removeItem('promo_trial_period');
        localStorage.removeItem('branch_promo');
        this.$store.dispatch('setPromoData', {
          promoCode: '',
          trialPeriod: 1,
          trialEndDate: '',
          header: '',
          subheader: '',
        }); // Removing promo code data after user
        this.$emit('success');
        this.$analytics.track('ga_subscription_created');

        /*
        // Send ClickedID to Segment in case present.
        let eventContext = {};
        if (this.getImpactClickId()) {
          eventContext = {
            context: {
              referrer: {
                type: 'impactRadius',
                id: this.getImpactClickId(),
              },
            },
          };
        }
        this.$analytics.track('Subscription Created', {}, eventContext);
        this.$store.dispatch('setIrClickId', null);
        */
      }
    },
    onCountryChange() {
      const country = this.countries.find(nextItem => nextItem.code === this.paymentForm.country);
      if (country && country.currency) {
        this.fetchZuoraProduct(country.currency);
      }
    },
    openPriceAlert() {
      const usersCountry = this.$store.getters.country;
      const pricing = this.fetchTargetCountryPrice();
      const currencyIcon = this.fetchCurrencySymbol(pricing.currency);
      const targetCountry = this.countries.find(country => country.code === this.paymentForm.country);
      this.$confirm(`You will be charged ${currencyIcon}${pricing.price} because your card is from ${targetCountry && targetCountry.name ? targetCountry.name : this.paymentForm.country}.`, {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        this.defaultPrice = pricing;
        this.verifyAddress();
      }).catch(() => {
        this.paymentForm.country = this.userSubscription && this.userSubscription.country ? this.userSubscription.country : usersCountry;
        this.activePlan = this.$store.getters.activePlan;
        this.defaultPrice = this.fetchTargetCountryPrice();
        this.verifyAddress();
      });
    },
    fetchTargetCountryPrice() {
      const country = this.countries.find(nextItem => nextItem.code === this.paymentForm.country);
      // const { activePlan } = this.$store.getters;
      const productRatePlanCharges = this.activePlan.productRatePlanCharges[this.activePlan.productRatePlanCharges.length - 1];
      const pricing = productRatePlanCharges.pricing.find(nextItem => nextItem.currency === country.currency);
      return pricing;
    },
    checkCountryIsWhiteListed() {
      const countryCode = this.supportedCountries.find(code => code === this.paymentForm.country);
      if (!countryCode) {
        this.paymentForm.country = '';
      }
    },
    calculateTrialEndDateLocally() {
      const promoCode = localStorage.getItem('promo_code');
      const promoTrailEndDate = localStorage.getItem('promo_trial_end_date');
      let currentDate = new Date();
      currentDate.setMonth(currentDate.getMonth() + 1);
      if (promoCode && promoTrailEndDate) {
        currentDate = promoTrailEndDate;
      }
      return currentDate;
    },
    fetchZuoraProduct(currencyCode) {
      this.loading = true;
      this.subscriptionProvider.fetchSubscriptionPlans(currencyCode).then((plan) => {
        this.loading = false;
        if (plan && plan.id) {
          this.activePlan = plan;
          this.openPriceAlert();
          this.$refs.paymentForm.clearValidate();
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    populateUserName() {
      const { user } = this.$store.getters;
      if (user && user.uuid) {
        this.paymentForm.firstName = user.first_name || '';
        this.paymentForm.lastName = user.last_name || '';
        this.paymentForm.postalCode = user.postal_code || '';
        this.paymentForm.state = user.state || '';
        this.paymentForm.country = this.userSubscription && this.userSubscription.country ? this.userSubscription.country : this.$store.getters.country;
      }
    },
    verifyAddress() {
      const { user } = this.$store.getters;
      if (this.paymentForm.country !== this.userSubscription.country) {
        this.paymentForm.postalCode = '';
        this.paymentForm.state = '';
      } else if (this.paymentForm.country === this.userSubscription.country) {
        this.paymentForm.postalCode = user.postal_code;
        this.paymentForm.state = user.state;
      }
      setTimeout(() => {
        this.$refs.paymentForm.clearValidate();
      }, 10);
    },
    validatePostalCode(rule, value, callback) {
      value = value.toString().trim();
      if (value === '') {
        callback(new Error('Postal code is required'));
      } else {
        const strongRegex = new RegExp(/^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z]\s?\d[ABCEGHJ-NPRSTV-Z]\d$/i);

        if (strongRegex.test(value)) {
          callback();
        } else {
          callback(new Error('Enter valid postal code.'));
        }
      }
    },
  },
};
</script>
<style lang="scss">
@import "../../assets/scss/variables.scss";
.update-payment-info {
  .el-select-dropdown__empty {
    font-size: 14px !important;
    font-weight: normal !important;
    color: #999 !important;
  }

  .heading{
    font-size: 40px;
    letter-spacing: -1;
    line-height: 44px;
    margin-bottom: 30px;
    font-family: "ITC Clearface";
  }
  .sub-head{
    margin-bottom: 24px;
    div:first-child{
      font-size: 16px;
      color: #111111;
    }
    div:last-child{
      font-size: 14px;
      color: #666666;
    }
  }
  .action-button{
    margin-top: 24px;
  }
  .el-form{
    max-width: 480px !important;
    width: 100% !important;
    margin: auto !important;
    margin-top: 30px;
    .el-form-item {
      margin-bottom: 16px;
      .el-form-item__label {
        color: $black;
        font-size: 16px;
        line-height: 28px;
        padding: 0px;
      }
      .el-form-item__label:before{
        content: none !important;
      }
      .el-input {
        .el-input__inner {
          height: 48px;
          border-radius: 8px;
          background-color: $xxlight-gray;
        }
      }
    }
  }
  .cards-div{
    .el-form-item{

      .el-form-item__label{
        padding: 0px;
      }
    }
    .js-iframe {
      max-height: 45px !important;
      min-height: 45px !important;
      background-color: $xxlight-gray;
      border-radius: 8px;
      .js-iframe-input.input-field {
        height: 48px;
        line-height: 48px;
        border: 1px solid #dcdfe6;
        border-radius: 8px;
      }
    }
    .custom-card-number{
      border: 1px solid #dcdfe6 !important;
      border-radius: 8px !important;
      background-color: $xxlight-gray;
      line-height: 12px;
      padding: 0 15px;
      #encryptedCardNumberSpan {
        .js-iframe {
          max-width: 100%;
          border: 0px !important;
        }
      }
    }
    .custom-exp-date {
      .el-form-item__content {
        background-color: $xxlight-gray;
        line-height: 12px;
        border: 1px solid #dcdfe6 !important;
        border-radius: 8px !important;
        padding: 0 0 0 15px;
      }
      .exp-month, .exp-year{
        margin-bottom: 0px;
        .el-form-item__content{
          background-color: transparent;
            border: 0px solid #dcdfe6 !important;
            padding: 0px;
          #encryptedExpiryYearSpan, #encryptedExpiryMonthSpan {
            line-height: 12px;
            .js-iframe {
              max-width: 100%;
              border: 0px !important;
              background-color: transparent;
              .js-iframe-input.input-field{
                height: 48px;
                line-height: 48px;
              }
            }
          }
        }
      }
    }
    .custom-cvv {
      border: 1px solid #dcdfe6 !important;
      border-radius: 8px !important;
      padding: 0 15px;
      background-color: $xxlight-gray;
      line-height: 12px;
      .js-iframe {
        max-width: 100%;
        border: 0px !important;
      }
    }
    .card-brand{
      img {
        width: 44px;
      }
    }
  }
  .legal-terms {
    color: #666 !important;

    a {
      color: #111111;
    }
  }
}
@media (max-width: 567px) {
  .update-payment-info{
    .cards-div {
      .card-brand {
        display: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/subscription/UpdatePaymentInfo.vue